module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "acknowledgements-title"
  }, [_c('a', {
    attrs: {
      "href": "#/toc#toc-acknowledgements"
    }
  }, [_vm._v("ACKNOWLEDGEMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("As always, "), _c('a', {
    attrs: {
      "id": "pvi"
    }
  }), _vm._v("this book has been enormously enriched by the help from many friends, colleagues and others. Michelle Schaffer and H. B. F. Dixon of King’s College and Derek Bendall of Trinity College, Cambridge helped to check the biochemistry. Chris Bayly, Mark Elvin, Brian Harrison and David Sneath gave advice on the history and anthropology. Lipeni, Christine and Dirang Lungalong showed us Calcutta. Mr and Mrs Singh, and Lily and Smo Das advised on Assam. Babs Johnson accompanied Iris on her trip to Assam. Brynny Lyster helped with research at the India Office Library. Hilda Martin provided her usual supportive advice (and cups of tea). Lily Blakely gave us an insight into how tea is transmitted in mother’s milk. David Dugan, Ian Duncan and Carlo Massarella helped in the filming of tea ceremonies and pursuing the tea theme. Andrew Morgan and Sally Dugan read the book carefully and offered excellent advice. Elizabeth Jones, then doing a dissertation in History and Philosophy of Science at Cambridge, read the text through twice and made many helpful criticisms. A number of her suggested quotations have been incorporated, especially in chapter 5. At Ebury Press, Jake Lingwood, Claire Kingston and all who helped to produce the book. Above all, "), _c('a', {
    attrs: {
      "id": "pvii"
    }
  }), _vm._v("much of the work came out of the discussions and careful reading and re-reading of the book by Sarah Harrison and Gerry Martin. And, of course, there are the countless people who have sacrificed their lives to produce tea over thousands of years, to a few of whom this book is dedicated. To all of them, deepest thanks.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bc40c2b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acknowledgements.vue
// module id = 72
// module chunks = 0